(function () {
// extends basic product slider but relies on API endpoint for its products so needs to take some extra steps during setup and init
// it relies a lot on side effects to reduce verbosity in JS setup
// this component uses CSS custom properties to control the scroll
// this class exists basically entirely to increment or decrement the properties
// does not support looping, obviously
function $3e4a18e8296fa0d3$var$clamp(num, min, max) {
    return Math.max(Math.min(num, Math.max(min, max)), Math.min(min, max));
}
class $3e4a18e8296fa0d3$export$ce700e3fb6bc889e {
    constructor(el){
        this.el = el;
        this.controls = this.el.querySelector(".product-slider__controls");
        this.productArea = this.el.querySelector(".product-slider__product-area");
        this.outer = this.el.querySelector(".product-slider__inner");
        this.navButtons = this.el.querySelectorAll("button[data-direction]");
        this.products = Array.from(this.el.querySelectorAll(".product-card"));
        this.currentSlideIndex = 0;
        this.slideCount = this.products.length;
    }
    init() {
        const slidesVisible = getComputedStyle(this.el).getPropertyValue("--slides-visible") * 1;
        console.log("slides visible: ", slidesVisible);
        if (this.slideCount <= slidesVisible) this.el.classList.add("no-overflow");
        this.navButtons.forEach((b)=>{
            b.addEventListener("click", (e)=>{
                const dir = b.dataset.direction;
                this.scroll(dir);
            });
        });
        this.productArea.scroll({
            left: 0,
            behavior: "instant"
        });
        this.currentSlideIndex = 1;
        this.scroll("prev");
        this.el.classList.add("initialized");
    }
    scroll(dir) {
        this.currentSlideIndex = dir == "prev" ? this.currentSlideIndex - 1 : this.currentSlideIndex + 1;
        const slidesVisible = getComputedStyle(this.el).getPropertyValue("--slides-visible") * 1;
        const maxIdx = this.currentSlideIndex + slidesVisible;
        this.currentSlideIndex = $3e4a18e8296fa0d3$var$clamp(this.currentSlideIndex, 0, this.slideCount - slidesVisible);
        this.products.forEach((s, idx)=>{
            const slideVisible = idx >= this.currentSlideIndex && idx < maxIdx;
            s.classList.toggle("visible", slideVisible);
            s.setAttribute("tabindex", slideVisible ? 0 : -1);
        });
        this.navButtons.forEach((b)=>{
            const isPrev = b.dataset.direction === "prev";
            const isNext = b.dataset.direction === "next";
            const isFirstSlide = this.currentSlideIndex === 0;
            const isLastSlide = this.currentSlideIndex + slidesVisible === this.slideCount;
            if (isPrev && isFirstSlide || isNext && isLastSlide) b.setAttribute("disabled", true);
            else b.removeAttribute("disabled");
        });
        const scrollOptions = {
            left: this.products[this.currentSlideIndex].offsetLeft,
            behavior: "smooth"
        };
        this.el.style.setProperty("--current-index", this.currentSlideIndex);
    }
}


class $eebbbbcc9bdabaae$export$63f6ffd1b8c38db1 extends (0, $3e4a18e8296fa0d3$export$ce700e3fb6bc889e) {
    constructor(el){
        super(el);
        this.currencyFormatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
        });
    }
    init() {
        this.productUrl = this.el.dataset.productUrl;
        // clone our card template and then remove it from the product area
        this.cardTemplate = this.productArea.querySelector("#product-card-template").cloneNode(true);
        this.cardTemplate.removeAttribute("id");
        this.productArea.innerHTML = "";
        // fetch products
        fetch(this.productUrl).then((res)=>res.json()).then((recData)=>{
            this.initializeProducts(recData.products);
        }).catch((err)=>{
            console.error(err);
        });
    }
    // set up products cards
    initializeProducts(products) {
        // create each card and add to product area
        products.forEach((p)=>{
            const c = this.cardTemplate.cloneNode(true);
            const title = c.querySelector("h3");
            const price = c.querySelector(".price");
            const inner = c.querySelector(".product-card");
            const img = c.querySelector("img");
            inner.classList.add("visible");
            c.setAttribute("href", p.url);
            img.setAttribute("src", p.featured_image);
            title.innerText = p.title;
            // divide by 100 to convert to dollars and cents
            price.innerText = this.currencyFormatter.format(p.price / 100);
            this.productArea.appendChild(c);
        });
        // update products array
        this.products = Array.from(this.productArea.querySelectorAll(".product-card"));
        // update slide count
        this.slideCount = this.products.length;
        // call init on product slider class
        super.init();
    }
}


window.addEventListener("DOMContentLoaded", ()=>{
    const relatedProductSliders = document.querySelectorAll(".related-product-slider");
    relatedProductSliders.forEach((s)=>{
        const x = new (0, $eebbbbcc9bdabaae$export$63f6ffd1b8c38db1)(s);
        x.init();
    });
});

})();
//# sourceMappingURL=relatedProductSlider.js.map
